import React, {useEffect, useState} from 'react';
import css from "./LogBook.module.scss";
import arrow from "../../../images/arrow-down.svg";
import throwFilter from "../../../images/throw_filters.svg";
import {ALL_PERIOD, ALL_TIME_BEFORE, ALL_TIME_FROM, CUSTOM, LAST_YEAR} from "../../../redux/types";
import {DateRange, Calendar} from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import {getFormattedDate, getStringDate} from "../../../utils";
import {COUNTRIES, CREW_ROLES, YACHT_TYPES} from "../../../redux/data/data-types";
import {connect} from "react-redux";
import {getCommonData} from "../../../redux/data/data-thunks";
import {getTrips} from "../../../redux/logbook/logbook-thunks";
import {useTranslation} from "react-i18next";


const Filters = ({isDark, selectedRoles, selectedYachtTypes, selectedTidal, selectedDateFilter,
                   state, beforeDate, fromDate, setSelectedDateFilter, setSelectedRoles, setSelectedYachtTypes,
                   setSelectedTidal, setState, setFromDate, setBeforeDate, selectedCountries, setSelectedCountries,
                   ...props}) => {
  const {t} = useTranslation()
  const [country, setCountry] = useState('')
  useEffect(() => {
    props.getCommonData(CREW_ROLES)
    props.getCommonData(YACHT_TYPES)
    props.getCommonData(COUNTRIES)
  }, [])
  useEffect(() => {
    let newDate = new Date()
    newDate.setFullYear(newDate.getFullYear() - 1)
    props.getTrips({
      roleIds: selectedRoles.map(r => r.id),
      yachtTypeIds: selectedYachtTypes.map(r => r.id),
      tidal: selectedTidal,
      countries: selectedCountries,
      dateBefore: selectedDateFilter === CUSTOM ? getStringDate(state[0].endDate)
        : selectedDateFilter === ALL_TIME_BEFORE ? getStringDate(beforeDate) : undefined,
      dateAfter: selectedDateFilter === CUSTOM ? getStringDate(state[0].startDate)
        : selectedDateFilter === ALL_TIME_FROM ? getStringDate(fromDate) :
          selectedDateFilter === LAST_YEAR ? getStringDate(newDate) : undefined
    })
  }, [selectedRoles, selectedYachtTypes, selectedTidal, fromDate, beforeDate, state, selectedDateFilter, selectedCountries])
  const dropFilters = () => {
    setSelectedDateFilter(ALL_PERIOD)
    setSelectedRoles([])
    setSelectedYachtTypes([])
    setSelectedTidal(undefined)
    props.getTrips()
  }
  const getDateFilter = (filter) => {
    switch (filter) {
      case ALL_PERIOD: return t('allPeriod')
      case CUSTOM: return `${getStringDate(state[0].endDate) ?? '...'} - ${getStringDate(state[0].startDate) ?? '...'}`
      case ALL_TIME_FROM: return `${t('from')} ${getStringDate(fromDate) ?? '...'}`
      case ALL_TIME_BEFORE: return `${t('until')} ${getStringDate(beforeDate) ?? '...'}`
      case LAST_YEAR: return `${t('lastYear')}`
      default: return t('allPeriod')
    }
  }

  const getValuesString = (placeholder, data, selectedData) => {
    if(selectedData?.length === 0) return placeholder
    else if(selectedData?.length === 1) return `${data.find(d => selectedData.indexOf(d.id) !== -1 || selectedData.find(s => s.id === d.id) !== undefined)?.name}`
    else return `${data.find(d => selectedData.indexOf(d.id) !== -1 || selectedData.find(s => s.id === d.id) !== undefined)?.name}, ...`
  }
  return (
    <div className={`${css.filters} ${isDark && css.filters__dark}`}>
      <div className={css.filters__buttonWrapper}>
        <button className={css.filter}>
          {getDateFilter(selectedDateFilter)}
          <img src={arrow} alt="" className={css.filter__arrow}/>
        </button>
        <div className={css.menuWrapper}>
          <div className={css.menu}>
            <div className={css.menu__col}>
              <button onClick={() => setSelectedDateFilter(ALL_PERIOD)}
                      className={`${css.menu__button} ${selectedDateFilter === ALL_PERIOD && css.menu__buttonSelected}`}>
                {t('allPeriod')}
              </button>
              <button onClick={() => setSelectedDateFilter(CUSTOM)}
                      className={`${css.menu__button} ${selectedDateFilter === CUSTOM && css.menu__buttonSelected}`}>
                {t('enterManually')}
              </button>
              <button onClick={() => setSelectedDateFilter(ALL_TIME_FROM)}
                      className={`${css.menu__button} ${selectedDateFilter === ALL_TIME_FROM && css.menu__buttonSelected}`}>
                {t('allTimeFrom')}...
              </button>
              <button onClick={() => setSelectedDateFilter(ALL_TIME_BEFORE)}
                      className={`${css.menu__button} ${selectedDateFilter === ALL_TIME_BEFORE && css.menu__buttonSelected}`}>
                {t('allTimeUntil')}...
              </button>
              <button onClick={() => setSelectedDateFilter(LAST_YEAR)}
                      className={`${css.menu__button} ${selectedDateFilter === LAST_YEAR && css.menu__buttonSelected}`}>
                {t('lastYear')}
              </button>
            </div>
            {(selectedDateFilter === CUSTOM) && <div className={css.menu__col}>
              <div className={css.menu__row}>
                <DateRange
                  editableDateInputs={true}
                  onChange={item => setState([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={state}
                  months={2}
                  className={css.datePicker}
                  direction={'horizontal'}
                  showDateDisplay={false}
                  rangeColors={['#2196F3']}
                />
              </div>
              <div className={`${css.menu__row} ${css.menu__dateInfo}`}>
                <p className={css.menu__date}>
                  {getFormattedDate(state[0].startDate)}-{getFormattedDate(state[0].endDate)}
                </p>
                <button onClick={() => setState([{...state[0], endDate: null, startDate: new Date()}])}
                        className="commonBtn">
                  <span className="commonBtn__label">{t('cancel')}</span>
                </button>
                <button disabled={!(state[0].startDate && state[0].endDate)}
                        className={`${state[0].startDate && state[0].endDate ? 'submit-button' : 'submit-button__disabled'}`}>
                  {t('choose')}
                </button>
              </div>
            </div>}
            {(selectedDateFilter === ALL_TIME_FROM) && <div className={css.menu__col}>
              <div className={css.menu__row}>
                <Calendar onChange={item => setFromDate(item)}
                          date={fromDate}/>
              </div>
              <div className={`${css.menu__row} ${css.menu__dateInfo}`}>
                <p className={css.menu__date}>
                  {t('from')} {getFormattedDate(fromDate)}
                </p>
                <button onClick={() => setFromDate(null)}
                        className="commonBtn">
                  <span className="commonBtn__label">{t('cancel')}</span>
                </button>
                <button disabled={!(fromDate)}
                        className={`${fromDate ? 'submit-button' : 'submit-button__disabled'}`}>
                  {t('choose')}
                </button>
              </div>
            </div>}
            {(selectedDateFilter === ALL_TIME_BEFORE) && <div className={css.menu__col}>
              <div className={css.menu__row}>
                <Calendar onChange={item => setBeforeDate(item)}
                          date={beforeDate}/>
              </div>
              <div className={`${css.menu__row} ${css.menu__dateInfo}`}>
                <p className={css.menu__date}>
                  {t('until')} {getFormattedDate(beforeDate)}
                </p>
                <button onClick={() => setBeforeDate(null)}
                        className="commonBtn">
                  <span className="commonBtn__label">{t('cancel')}</span>
                </button>
                <button disabled={!(beforeDate)}
                        className={`${beforeDate ? 'submit-button' : 'submit-button__disabled'}`}>
                  {t('choose')}
                </button>
              </div>
            </div>}
          </div>
        </div>
      </div>
      <div className={css.filters__buttonWrapper}>
        <button className={css.filter}>
          {getValuesString(t('role'), props.crewRoles, selectedRoles)}
          <img src={arrow} alt="" className={css.filter__arrow}/>
        </button>
        <div className={css.menuWrapper}>
          <div className={css.menu}>
            <div className={css.menu__col}>
              {props.crewRoles.map((c, index) => (
                <button key={index} onClick={() => {
                  if (selectedRoles.find(r => r.name === c.name) !== undefined) {
                    setSelectedRoles([...selectedRoles].filter(r => r.name !== c.name))
                  } else {
                    setSelectedRoles([...selectedRoles, c])
                  }
                }}
                        className={`${css.menu__button} ${selectedRoles.find(r => r.name === c.name) !== undefined && css.menu__buttonSelected}`}>
                  {c.name}
                </button>))}
            </div>
          </div>
        </div>
      </div>
      <div className={css.filters__buttonWrapper}>
        <button className={css.filter}>
          {getValuesString(t('yachtType'), props.yachtTypes, selectedYachtTypes)}
          <img src={arrow} alt="" className={css.filter__arrow}/>
        </button>
        <div className={css.menuWrapper}>
          <div className={css.menu}>
            <div className={css.menu__col}>
              {props.yachtTypes.map((y, index) => (
                <button key={index} onClick={() => {
                  if (selectedYachtTypes.find(s => s.name === y.name) !== undefined) {
                    setSelectedYachtTypes([...selectedYachtTypes].filter(r => r.name !== y.name))
                  } else {
                    setSelectedYachtTypes([...selectedYachtTypes, y])
                  }
                }}
                        className={`${css.menu__button} ${selectedYachtTypes.find(s => s.name === y.name) !== undefined && css.menu__buttonSelected}`}>
                  {y.name}
                </button>))}
            </div>
          </div>
        </div>
      </div>
      <div className={css.filters__buttonWrapper}>
        <button className={css.filter}>
          <input placeholder={getValuesString(t('country'), props.countries, selectedCountries)} className={css.filter__input}
                 value={country} onChange={(e) => {
            setCountry(e.target.value)
            props.getCommonData(COUNTRIES, e.target.value)
          }}
                 type="text"/>
          <img src={arrow} alt="" className={css.filter__arrow}/>
        </button>
        <div className={css.menuWrapper}>
          <div className={css.menu}>
            <div className={css.menu__col}>
              {props.countries.map((y, index) => (
                <button key={index} onClick={() => {
                  if (selectedCountries.find(c => c === y.id) !== undefined) {
                    setSelectedCountries([...selectedCountries].filter(c => c !== y.id))
                  } else {
                    setSelectedCountries([...selectedCountries, y.id])
                  }
                }}
                        className={`${css.menu__button} ${selectedCountries.find(c => c === y.id) !== undefined && css.menu__buttonSelected}`}>
                  {y.name}
                </button>))}
            </div>
          </div>
        </div>
      </div>
      <div className={css.filters__buttonWrapper}>
        <button className={css.filter}>
          {selectedTidal === true || selectedTidal === undefined ? t('tidal') : t('nonTidalRegion')}
          <img src={arrow} alt="" className={css.filter__arrow}/>
        </button>
        <div className={css.menuWrapper}>
          <div className={css.menu}>
            <div className={css.menu__col}>
              <button onClick={() => {
                if (!selectedTidal) {
                  setSelectedTidal(true)
                } else {
                  setSelectedTidal(undefined)
                }
              }}
                      className={`${css.menu__button} ${selectedTidal === true && css.menu__buttonSelected}`}>
                {t('tidalRegion')}
              </button>
              <button onClick={() => {
                if (selectedTidal === false) {
                  setSelectedTidal(undefined)
                } else {
                  setSelectedTidal(false)
                }
              }}
                      className={`${css.menu__button} ${selectedTidal === false && css.menu__buttonSelected}`}>
                {t('nonTidalRegion')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <button onClick={dropFilters} className={css.filterThrow}>
        <img src={throwFilter} alt="" className={css.filterThrow__icon}/>
        {t('clearFilters')}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  crewRoles: state.dataReducer.crewRoles,
  yachtTypes: state.dataReducer.yachtTypes,
  countries: state.dataReducer.countries
})

export default connect(mapStateToProps, {getCommonData, getTrips})(React.memo(Filters));
